
module.exports = {
  "colors": {
    
      "baseCoral":  "#ff5c39",
    
      "baseRed":  "#dc2222",
    
      "baseGold":  "#d6cf8d",
    
      "baseGreen":  "#3ba150",
    
      "baseNavy":  "#001e62",
    
      "basePink":  "#ff808b",
    
      "baseTeal":  "#00a5ad",
    
      "baseYellow":  "#ffb500",
    
      "grey10":  "#f8f8f8",
    
      "grey30":  "#e0e0e0",
    
      "grey50":  "#bebebe",
    
      "grey70":  "#707070",
    
      "grey90":  "#3b3b3b",
    
      "transparentLight":  "rgba(255, 255, 255, 0.6)",
    
      "transparentDark":  "rgba(0, 0, 0, 0.6)",
    
      "white":  "#ffffff",
    
      "red10":  "#fff3f0",
    
      "red100":  "#961717",
    
      "coral10":  "#ffeeea",
    
      "coral100":  "#cb3a29",
    
      "gold10":  "#f7f5e6",
    
      "gold100":  "#726d40",
    
      "green10":  "#ecffea",
    
      "green100":  "#37824b",
    
      "navy10":  "#e7efff",
    
      "navy100":  "#0d1e44",
    
      "pink10":  "#fff0f1",
    
      "pink100":  "#c24353",
    
      "teal10":  "#e6f9fa",
    
      "teal100":  "#2f7b84",
    
      "yellow10":  "#fef1d1",
    
      "yellow100":  "#9a6914",
    
      "bloomBaseNavy800":  "#071948",
    
      "bloomBaseBlue600":  "#4036ed",
    
      "bloomBaseCoral600":  "#ff6668",
    
      "bloomBaseTeal600":  "#11c6cf",
    
      "bloomGreen700":  "#008354",
    
      "bloomGreen400":  "#73cfa3",
    
      "bloomGreen100":  "#f1fff8",
    
      "bloomBasePurple600":  "#8e5aff",
    
      "bloomBaseYellow600":  "#ffcb4d",
    
      "bloomBasePink600":  "#f89099",
    
      "bloomGreyNavy800":  "#071948",
    
      "bloomGreyNavy700":  "#36456b",
    
      "bloomGreyNavy600":  "#515e7f",
    
      "bloomGreyNavy500":  "#838ca3",
    
      "bloomGreyNavy400":  "#b5bac8",
    
      "bloomGreyNavy300":  "#e6e8ed",
    
      "bloomGreyNavy200":  "#f3f4f6",
    
      "bloomGreyNavy100":  "#f8f8fa",
    
      "bloomBlue700":  "#2c25a5",
    
      "bloomBlue400":  "#7972f2",
    
      "bloomBlue200":  "#b2aef7",
    
      "bloomBlue100":  "#ebeafd",
    
      "bloomCoral700":  "#b24748",
    
      "bloomCoral400":  "#ff9395",
    
      "bloomCoral200":  "#ffc1c2",
    
      "bloomCoral100":  "#ffefef",
    
      "bloomTeal700":  "#0b8a90",
    
      "bloomTeal400":  "#58d7dd",
    
      "bloomTeal200":  "#9fe8eb",
    
      "bloomTeal100":  "#e7f9fa",
    
      "bloomYellow700":  "#b28e35",
    
      "bloomYellow400":  "#ffda82",
    
      "bloomYellow200":  "#ffeab7",
    
      "bloomYellow100":  "#fff9ed",
    
      "bloomPink700":  "#b28085",
    
      "bloomPink400":  "#ffcdd1",
    
      "bloomPink200":  "#ffe2e5",
    
      "bloomPink100":  "#fff7f8",
    
      "bloomPurple700":  "#633eb2",
    
      "bloomPurple400":  "#af8bff",
    
      "bloomPurple200":  "#d1bdff",
    
      "bloomPurple100":  "#f3eeff",
    
      "bloomOchre700":  "#86640c",
    
      "bloomOchre400":  "#eab65c",
    
      "bloomOchre100":  "#fdf5eb",
    
      "bloomRed700":  "#d02b0b",
    
      "bloomRed400":  "#ff5641",
    
      "bloomRed100":  "#fdf4f4",
    
  },

  "spacings": {
    
      "xxs":  "0.25rem",
    
      "xs":  "0.5rem",
    
      "sm":  "0.75rem",
    
      "md":  "1rem",
    
      "lg":  "1.5rem",
    
      "xl":  "2rem",
    
      "xxl":  "2.5rem",
    
  },

  "spacingsPx": {
    
      "xxs":  4,
    
      "xs":  8,
    
      "sm":  12,
    
      "md":  16,
    
      "lg":  24,
    
      "xl":  32,
    
      "xxl":  40,
    
  },

  "textStyles": {
    
      "footnote":  "0.75rem",
    
      "footnoteHeavy":  "0.75rem",
    
      "caption":  "0.875rem",
    
      "captionHeavy":  "0.875rem",
    
      "body":  "1rem",
    
      "bodyHeavy":  "1rem",
    
      "smHeader":  "1rem",
    
      "mdHeader":  "1.125rem",
    
      "mdHeaderRegular":  "1.125rem",
    
      "lgHeader":  "1.25rem",
    
      "lgHeaderRegular":  "1.25rem",
    
      "xlHeader":  "1.5rem",
    
      "hugeHeader":  "1.75rem",
    
      "smHero":  "2rem",
    
      "smHeroRegular":  "2rem",
    
      "mdHero":  "2.5rem",
    
      "lgHero":  "3.375rem",
    
      "hugeHero":  "4.5rem",
    
  },

    "AssetFontTreatwellSansWebRegularName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebRegularStyle": "normal",
    "AssetFontTreatwellSansWebRegularWeight": "normal",
    "AssetFontTreatwellSansWebRegularWoff": "assets/fonts/TreatwellSansWeb-Regular/TreatwellSansWeb-Regular.woff",
    "AssetFontTreatwellSansWebRegularWoff2": "assets/fonts/TreatwellSansWeb-Regular/TreatwellSansWeb-Regular.woff2",
    "AssetFontTreatwellSansWebRegularDisplay": "swap",
    "AssetFontTreatwellSansWebRegularItalicName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebRegularItalicStyle": "italic",
    "AssetFontTreatwellSansWebRegularItalicWeight": "normal",
    "AssetFontTreatwellSansWebRegularItalicWoff": "assets/fonts/TreatwellSansWeb-RegularItalic/TreatwellSansWeb-RegularItalic.woff",
    "AssetFontTreatwellSansWebRegularItalicWoff2": "assets/fonts/TreatwellSansWeb-RegularItalic/TreatwellSansWeb-RegularItalic.woff2",
    "AssetFontTreatwellSansWebRegularItalicDisplay": "swap",
    "AssetFontTreatwellSansWebBoldName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebBoldStyle": "normal",
    "AssetFontTreatwellSansWebBoldWeight": "bold",
    "AssetFontTreatwellSansWebBoldWoff": "assets/fonts/TreatwellSansWeb-Bold/TreatwellSansWeb-Bold.woff",
    "AssetFontTreatwellSansWebBoldWoff2": "assets/fonts/TreatwellSansWeb-Bold/TreatwellSansWeb-Bold.woff2",
    "AssetFontTreatwellSansWebBoldDisplay": "swap",
    "AssetFontTreatwellSansWebBoldItalicName": "TreatwellSansWeb",
    "AssetFontTreatwellSansWebBoldItalicStyle": "italic",
    "AssetFontTreatwellSansWebBoldItalicWeight": "bold",
    "AssetFontTreatwellSansWebBoldItalicWoff": "assets/fonts/TreatwellSansWeb-BoldItalic/TreatwellSansWeb-BoldItalic.woff",
    "AssetFontTreatwellSansWebBoldItalicWoff2": "assets/fonts/TreatwellSansWeb-BoldItalic/TreatwellSansWeb-BoldItalic.woff2",
    "AssetFontTreatwellSansWebBoldItalicDisplay": "swap",
    "ColorBaseCoral": "#ff5c39",
    "ColorBaseRed": "#dc2222",
    "ColorBaseGold": "#d6cf8d",
    "ColorBaseGreen": "#3ba150",
    "ColorBaseNavy": "#001e62",
    "ColorBasePink": "#ff808b",
    "ColorBaseTeal": "#00a5ad",
    "ColorBaseYellow": "#ffb500",
    "ColorGrey10": "#f8f8f8",
    "ColorGrey30": "#e0e0e0",
    "ColorGrey50": "#bebebe",
    "ColorGrey70": "#707070",
    "ColorGrey90": "#3b3b3b",
    "ColorTransparentLight": "rgba(255, 255, 255, 0.6)",
    "ColorTransparentDark": "rgba(0, 0, 0, 0.6)",
    "ColorWhite": "#ffffff",
    "ColorRed10": "#fff3f0",
    "ColorRed100": "#961717",
    "ColorCoral10": "#ffeeea",
    "ColorCoral100": "#cb3a29",
    "ColorGold10": "#f7f5e6",
    "ColorGold100": "#726d40",
    "ColorGreen10": "#ecffea",
    "ColorGreen100": "#37824b",
    "ColorNavy10": "#e7efff",
    "ColorNavy100": "#0d1e44",
    "ColorPink10": "#fff0f1",
    "ColorPink100": "#c24353",
    "ColorTeal10": "#e6f9fa",
    "ColorTeal100": "#2f7b84",
    "ColorYellow10": "#fef1d1",
    "ColorYellow100": "#9a6914",
    "ColorBloomBaseNavy800": "#071948",
    "ColorBloomBaseBlue600": "#4036ed",
    "ColorBloomBaseCoral600": "#ff6668",
    "ColorBloomBaseTeal600": "#11c6cf",
    "ColorBloomGreen700": "#008354",
    "ColorBloomGreen400": "#73cfa3",
    "ColorBloomGreen100": "#f1fff8",
    "ColorBloomBasePurple600": "#8e5aff",
    "ColorBloomBaseYellow600": "#ffcb4d",
    "ColorBloomBasePink600": "#f89099",
    "ColorBloomGreyNavy800": "#071948",
    "ColorBloomGreyNavy700": "#36456b",
    "ColorBloomGreyNavy600": "#515e7f",
    "ColorBloomGreyNavy500": "#838ca3",
    "ColorBloomGreyNavy400": "#b5bac8",
    "ColorBloomGreyNavy300": "#e6e8ed",
    "ColorBloomGreyNavy200": "#f3f4f6",
    "ColorBloomGreyNavy100": "#f8f8fa",
    "ColorBloomBlue700": "#2c25a5",
    "ColorBloomBlue400": "#7972f2",
    "ColorBloomBlue200": "#b2aef7",
    "ColorBloomBlue100": "#ebeafd",
    "ColorBloomCoral700": "#b24748",
    "ColorBloomCoral400": "#ff9395",
    "ColorBloomCoral200": "#ffc1c2",
    "ColorBloomCoral100": "#ffefef",
    "ColorBloomTeal700": "#0b8a90",
    "ColorBloomTeal400": "#58d7dd",
    "ColorBloomTeal200": "#9fe8eb",
    "ColorBloomTeal100": "#e7f9fa",
    "ColorBloomYellow700": "#b28e35",
    "ColorBloomYellow400": "#ffda82",
    "ColorBloomYellow200": "#ffeab7",
    "ColorBloomYellow100": "#fff9ed",
    "ColorBloomPink700": "#b28085",
    "ColorBloomPink400": "#ffcdd1",
    "ColorBloomPink200": "#ffe2e5",
    "ColorBloomPink100": "#fff7f8",
    "ColorBloomPurple700": "#633eb2",
    "ColorBloomPurple400": "#af8bff",
    "ColorBloomPurple200": "#d1bdff",
    "ColorBloomPurple100": "#f3eeff",
    "ColorBloomOchre700": "#86640c",
    "ColorBloomOchre400": "#eab65c",
    "ColorBloomOchre100": "#fdf5eb",
    "ColorBloomRed700": "#d02b0b",
    "ColorBloomRed400": "#ff5641",
    "ColorBloomRed100": "#fdf4f4",
    "FontFamilyBase": "Arial, Helvetica, sans-serif",
    "FontFamilyTreatwell": "TreatwellSansWeb, Arial, Helvetica, sans-serif",
    "FontStyleNormal": "normal",
    "FontStyleBold": "bold",
    "SizeFontFootnote": "0.75rem",
    "SizeFontFootnoteHeavy": "0.75rem",
    "SizeFontCaption": "0.875rem",
    "SizeFontCaptionHeavy": "0.875rem",
    "SizeFontBody": "1rem",
    "SizeFontBodyHeavy": "1rem",
    "SizeFontSmHeader": "1rem",
    "SizeFontMdHeader": "1.125rem",
    "SizeFontMdHeaderRegular": "1.125rem",
    "SizeFontLgHeader": "1.25rem",
    "SizeFontLgHeaderRegular": "1.25rem",
    "SizeFontXlHeader": "1.5rem",
    "SizeFontHugeHeader": "1.75rem",
    "SizeFontSmHero": "2rem",
    "SizeFontSmHeroRegular": "2rem",
    "SizeFontMdHero": "2.5rem",
    "SizeFontLgHero": "3.375rem",
    "SizeFontHugeHero": "4.5rem",
    "SizeLineHeightFootnote": "1.25rem",
    "SizeLineHeightCaption": "1.25rem",
    "SizeLineHeightBody": "1.5rem",
    "SizeLineHeightSmHeader": "1.5rem",
    "SizeLineHeightMdHeader": "1.5rem",
    "SizeLineHeightMdHeaderRegular": "1.5rem",
    "SizeLineHeightLgHeader": "1.5rem",
    "SizeLineHeightLgHeaderRegular": "1.5rem",
    "SizeLineHeightXlHeader": "1.625rem",
    "SizeLineHeightHugeHeader": "2.125rem",
    "SizeLineHeightSmHero": "2.25rem",
    "SizeLineHeightSmHeroRegular": "2.25rem",
    "SizeLineHeightMdHero": "2.75rem",
    "SizeLineHeightLgHero": "3.875rem",
    "SizeLineHeightHugeHero": "5rem",
    "SpacingXxs": "4",
    "SpacingXs": "8",
    "SpacingSm": "12",
    "SpacingMd": "16",
    "SpacingLg": "24",
    "SpacingXl": "32",
    "SpacingXxl": "40",
  
};



